import './App.css'
import * as Sentry from '@sentry/react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import AdminDashboard from './pages/AdminDashboard'
import SuperAdminDashboard from './pages/SuperAdminDashboard'
import Datenschutz from './pages/Datenschutz'
import AVV from './pages/AVV'
import AGB from './pages/AGB'
import Impressum from './pages/Impressum'
import LandingPage from './pages/LandingPage'
import ShopPage from './pages/ShopPage'
import KartePage from './pages/KartePage'
import ProduktvideoPage from './pages/ProduktvideoPage'

function ErrorFallback() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Ein Fehler ist aufgetreten</h2>
      <p>Bitte lade die Seite neu. Das Problem wurde automatisch gemeldet.</p>
      <button onClick={() => window.location.reload()}>Neu laden</button>
    </div>
  )
}

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/video" element={<ProduktvideoPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/karte" element={<KartePage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/super-admin" element={<SuperAdminDashboard />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/avv" element={<AVV />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  )
}

export default App
